<template>
  <a-card :bordered="false">
    <div>
      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="familyName"
          :title="$t('FAMILY_NAME') || '姓'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="personalName"
          :title="$t('PERSONAL_NAME') || '名'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="phone"
          :title="$t('TELEPHONE') || '手机' "
          width="180">
        </a-table-column>
        <a-table-column
          data-index="createAt"
          :title="$t('CREATE_AT') || '创建时间'"
          width="180">
          <template slot-scope="text,record">
            <time-formatter :time="record.postAt" format="YYYY-MM-DD HH:mm:ss"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="status"
          :title="$t('STATUS') || '状态'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" v-if="record.status !=='SUCCESS'" @click="editInvitation(record.id)">审核</a-button>
            <a-button type="link" @click="deleteInvitation(record.id)">{{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="审核情况"
      v-model="form.visible">
      <invitation-edit
        v-if="form.visible"
        :invitation-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </invitation-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryInvitations,
  _deleteInvitation
} from '@/api/invitationApi';
import TimeFormatter from '../../../components/TimeFormatter.vue';
import InvitationEdit from './InvitationEdit.vue';

async function getInvitations() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryInvitations({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getInvitations();
}

async function deleteInvitation(invitationId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteInvitation(invitationId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      await this.getInvitations();
    },
  });
}

async function editInvitation(invitationId) {
  // this.$confirm({
  //   title: '是否将该用户设置为审核通过',
  //   content: '',
  //   onOk: async () => {
  //     await _deleteInvitation(newsId);
  //     this.$message.success(this.$t('审核通过'));
  //     await this.getInvitations();
  //   },
  // });
  this.form.data.id = invitationId;
  this.form.visible = true;
}
export default {
  name: 'Invitation',
  components: {
    TimeFormatter,
    InvitationEdit
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getInvitations,
    closeForm,
    deleteInvitation,
    editInvitation,
  },
  async created() {
    await this.getInvitations();
  },
};
</script>

<style scoped>

</style>
